import React, { useEffect, useState } from 'react';

import { QBox, QText } from '@captivateiq/quotient';

export const ThinkingLoader = () => {
  const [dots, setDots] = useState('');

  // Animate ellipsis dots
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : `${prev}.`));
    }, 400);
    return () => clearInterval(interval);
  }, []);

  return (
    <QBox>
      <QText sx={{ color: 'text.onSurface.background.mediumContrast', fontStyle: 'italic' }} variant="smallRegular">
        Thinking{dots}
      </QText>
    </QBox>
  );
};
